import type { ChoiceChipOption } from '@/components/ChoiceChips/ChoiceChips';
import type { TranslationKey } from '@/i18n-key';

import { useAmelioTranslations } from '@/hooks';
import { validationMessageKey } from '@/utils/validationMessage';

/**
 * The wording every question of the "Aspirations de carrière" form shares: chips that name their own
 * key, and a validation message, which the schema carries as a translation key.
 */
export const useCareerAspirationFormText = () => {
    const { t } = useAmelioTranslations();

    const optionsOf = <T extends string>(
        values: readonly T[],
        keyOf: (value: T) => TranslationKey,
    ): ChoiceChipOption<T>[] => values.map((value) => ({ value, label: t(keyOf(value)) }));

    const errorMessage = (message?: string) =>
        message ? t(validationMessageKey(message)) : undefined;

    return { t, optionsOf, errorMessage };
};
